import {getRecordPath, getRecordUrlId} from 'shared/utils/data-service-utils';
import type {Rec, ViewableSearch} from 'typings/portaro.be.types';
import type LoginService from 'shared/login/login.service';
import type SdiRequestsDataService from '../../sdi-requests/sdi-requests.data-service';
import type CurrentAuthService from 'shared/services/current-auth.service';
import type FinishedResponseInteractionService from 'shared/services/finished-response-interaction.service';
import type WalkerService from 'shared/services/walker.service';
import type {FavouritesCollectionService} from '../../favourites/favourites-collection.service';

export class SearchPageService {
    public static serviceName = 'searchPageService';

    /*@ngInject*/
    constructor(private favouritesCollectionService: FavouritesCollectionService,
                private loginService: LoginService,
                private sdiRequestsDataService: SdiRequestsDataService,
                private currentAuthService: CurrentAuthService,
                private finishedResponseInteractionService: FinishedResponseInteractionService,
                private walker: WalkerService) {
    }
    public async getFavouritesCollectionManager() {
        return this.favouritesCollectionService.getFavouritesCollectionManager();
    }

    public registerPotentials(records: Rec[]) {
        records.forEach((record) => this.favouritesCollectionService.registerPotential(record));
    }

    public clearPotentials() {
        this.favouritesCollectionService.clearPotentials();
    }

    public async addSdiRequest(search: ViewableSearch<any, any>) {
        try {
            await this.loginService.login();
            const response = await this.sdiRequestsDataService.createSdiRequest({
                search,
                user: this.currentAuthService.getActiveUser()
            });
            await this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(response);
        } catch (exceptionResponse) {
            this.finishedResponseInteractionService.showFailedResponseInToast(exceptionResponse);
        }
    };

    public goToRecord(record: Rec) {
        return this.walker.newPage(getRecordPath(getRecordUrlId(record)));
    }
}